<div class="export-wizard-component" [class.close]="shouldClose" [class.business-analyst]="isBusinessAnalyst">
  <steps-manager [stepsCount]="0" [currentStep]="null" [displayCloseButton]="true" (onCloseClicked)="onCloseClicked()"></steps-manager>
  <div>&nbsp;</div>

  <div *ngIf="isBusinessAnalyst && selectedExports.length" class="publish-unpublish-button" (click)="publishUnpublishClicked()">
    <svg-icon *ngIf="publishedExportsView" src="./assets/icons/unpublish.svg" align="center" class="menu-action-icon svg-icon-gray" title="UNPUBLISH"></svg-icon>
    <svg-icon *ngIf="!publishedExportsView" src="./assets/icons/publish.svg" align="center" class="menu-action-icon svg-icon-gray" title="PUBLISH"></svg-icon>
  </div>

  <header class="export-section-title">
    <h1>{{ 'export.exportTitle' | translate }}</h1>
  </header>

  <div *ngIf="isBusinessAnalyst" class="publish-unpublish-radios">

    <label>
      <input type="radio" name="publish-unpublish-options" value="1" [checked]="publishedExportsView" (change)='showPublishedExportsChoosen(true)' />
      <span class="radio-label">{{'export.publishedExports' | translate}}</span>
    </label>

    <label>
      <input class="unpublished-radio" type="radio" name="publish-unpublish-options" value="0" [checked]="!publishedExportsView" (change)='showPublishedExportsChoosen(false)' />
      <span class="radioClass">{{'export.unpublishedExports' | translate}}</span>
    </label>
    
  </div>

  <section class="export-section">
    <h2>{{'export.exportSectionTitle' | translate}}</h2>

    <p class="export-help-text">
      {{'export.helpTextMessage' | translate}}<br />
    </p>

    <kendo-grid [data]="gridTemplates"
                [selectable]="selectableSettings"
                kendoGridSelectBy="id"
                [(selectedKeys)]="selectedExports">

      <kendo-grid-checkbox-column title="" [width]="40" *ngIf="isBusinessAnalyst">
        <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
          <ng-container *ngIf="dataItem.id > 0">
            <input [kendoGridSelectionCheckbox]="idx" />
          </ng-container>
        </ng-template>
      </kendo-grid-checkbox-column>

      <kendo-grid-column field="templateName" title="Template name">
      </kendo-grid-column>
      <kendo-grid-column field="createdAt" title="Created at">
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="dataItem.createdAt">{{dataItem.createdAt | date: 'dd/MM/yyyy'}}</ng-container>
          <ng-container *ngIf="!dataItem.createdAt">N/A</ng-container>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </section>

  <div class="buttons-container">
    <button kendoButton class="next" *ngIf="selectedExports && selectedExports.length === 1" (click)="export()">{{'export.createExport' | translate}}</button>
  </div>
</div>
